import { SelectOption } from "./types";

export const NONE_SELECTED_OPTION: SelectOption = {
  id: "null",
  value: "None",
};

export const EMPTY_SELECT_OPTION: SelectOption = {
  id: "",
  value: "",
  label: "",
};
